import cn from 'classnames';

import { useInt } from 'hooks/useInt';

import { Button } from 'ui/atoms/Button/Button';
import { Image } from 'ui/atoms/Image';

import styles from './CtaBanner.module.scss';

import type { CtaBannerProps } from './CtaBanner.types';

export const CtaBanner = ({ title, buttonText, ctaHref, theme, contained, className }: CtaBannerProps) => {
  const { t } = useInt();

  const banner =
    theme === 'glass' ? (
      <div className={styles.ctaGlassOuter}>
        <div className={styles.ctaGlassLayer1} aria-hidden="true" />
        <div className={styles.ctaGlassLayer2} aria-hidden="true" />
        <div className={styles.ctaGlassLayer3} aria-hidden="true" />
        <div className={styles.ctaGlassLayer4} aria-hidden="true" />

        <div className={cn(styles.cta, styles.cta_glass, className)}>
          <div className={styles.ctaGlassBg} aria-hidden="true">
            <Image src="images/cta-banner-bg.png" width={771} height={491} alt="" priority={false} />
          </div>

          <p className={styles.title}>{title}</p>

          {ctaHref && (
            <Button type="blue" size="xl" route={ctaHref} className={styles.button}>
              {buttonText ?? t('Request a demo')}
            </Button>
          )}
        </div>
      </div>
    ) : (
      <div className={cn(styles.cta, theme && styles[`cta_${theme}`], className)}>
        <p className={styles.title}>{title}</p>

        {ctaHref && (
          <Button type="white" size="xl" route={ctaHref} className={styles.button}>
            {buttonText ?? t('Request a demo')}
          </Button>
        )}
      </div>
    );

  if (contained) {
    return <div className={styles.container}>{banner}</div>;
  }

  return banner;
};
